<template>
    <div class="p-3 border-b-2 border-next-gray-md mb-3" :class="{'bg-green-100': versione?.manual}">
        <div class="grid grid-cols-5 gap-3">
            <div class="text-sm font-bold">Totale ricavi</div>
            <div class="text-sm font-bold">Totale costi</div>
            <div class="text-sm font-bold">Utile</div>
            <div class="text-sm font-bold">Margine</div>
            <div class="text-sm font-bold">Fees</div>

            <div class="py-2 px-4 bg-next-gray-md">{{
                    ActiveTab && TotaleRicaviProgetto(ActiveTab.sezioni) ? TotaleRicaviProgetto(ActiveTab.sezioni).toLocaleValueString() : '-'
                }}
            </div>
            <div class="py-2 px-4 bg-next-gray-md">{{
                    ActiveTab && TotaleCostiEuroProgetto(ActiveTab.sezioni) ? $filters.toEuroCurrency(TotaleCostiEuroProgetto(ActiveTab.sezioni)) : '-'
                }}
            </div>
            <div class="py-2 px-4 bg-next-gray-md">{{
                    ActiveTab && TotaleUtiliProgetto(ActiveTab.sezioni).toLocaleValueString() ? `€ ${TotaleUtiliProgetto(ActiveTab.sezioni).toLocaleValueString()}` : '-'
                }}
            </div>
            <div class="py-2 px-4 bg-next-gray-md">{{
                    ActiveTab && TotaleMolFee(ActiveTab.sezioni) ? `${TotaleMolFee(ActiveTab.sezioni).toLocaleValueString()} %` : '-'
                }}
            </div>
            <div class="py-2 px-4 bg-next-gray-md">{{
                    ActiveTab && TotaleFeesSezioni(ActiveTab.sezioni) ? $filters.toEuroCurrency(TotaleFeesSezioni(ActiveTab.sezioni)) : '-'
                }}
            </div>
            <div class="col-span-4">
                <p class="text-sm"><i class="icon icon-flag text-next-orange"></i> Versione {{
                        versione.major
                    }}.{{ versione.minor }} create da <b>{{ versione.created_by_label }}</b> il
                    {{ $filters.toDate(versione.created_at) }} alle {{ $filters.toTime(versione.created_at) }}</p>
                <p v-show="versione?.nota" class="text-sm inline mr-3"><i class="icon icon-ferie_permessi"></i>
                    {{ versione?.nota }}</p>

                <MultiselectOption v-for="(tag,i) in tags" :key="i" readonly="1" class="inline">{{
                        tag
                    }}
                </MultiselectOption>
            </div>
            <div class="flex items-start">
                <NextButton variant="outline-primary" component="router-link" class="p-2 w-full"
                            :to="{name:'DettaglioVersioneSottoProgetto', params:{id:sottoprogetto.id, idv:versione.id}}">Vedi offerta
                </NextButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import BadgeStato from "@/components/BadgeStato.vue";
import NextButton from "@/components/NextButton.vue";
import {mapGetters} from 'vuex';
import MultiselectOption from "@/components/MultiselectOption.vue";

@Options({
    name: 'VersioneSottoProgetto',
    inject: ['getColoreStato', 'getLabelStato'],
    components: {
        MultiselectOption,
        NextButton,
        BadgeStato
    },
    props: {
        versione: Object,
        sottoprogetto: Object,
    },
    computed: {
        ...mapGetters('sprjDataManager', [
            'TotaleCostiEuroProgetto',
            'TotaleUtiliProgetto',
            'TotaleRicaviProgetto',
            'TotaleMolFee',
            'TotaleFeesSezioni'
        ]),
    },
})
export default class VersioneSottoProgetto extends Vue {
    versione!: any

    get ActiveTab() {
        if (this.versione?.data?.tabs && this.versione?.data.active_tab != undefined && this.versione?.data.tabs[this.versione?.data.active_tab]) {
            return this.versione?.data.tabs[this.versione?.data.active_tab]
        }
        return null
    }

    get tags() {
        return JSON.parse(this.versione.tags)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
